import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import { SignalEvent } from '../models/signal-event';
import { SignalEventType } from '../models/signal-event-type';

@Injectable()
export abstract class SignalRService {
  abstract getDataStream<TDataShape>(...filterValues: SignalEventType[]): Observable<SignalEvent<TDataShape>>
}